import type {
  ReactElement,
} from 'react';

import { renderGroupItem } from './LinksGroup';

import type {
  SidebarRenderType,
  SidebarLink,
  SidebarLinksGroup,
} from './types';

export type LinksGroupsProps = {
  linksGroups: (SidebarLink | SidebarLinksGroup)[];
  level: number;
  counters: {
    [key: string]: number | { count: number; isError?: boolean; };
  };
  countersMaxNumber?: number | null;
  showCountersInOpenedState: boolean;
  renderType: SidebarRenderType;

  linksPath?: number[];
  hoverGroupIndex?: number | null;
  openedGroups: {
    [key: string]: boolean;
  };
  openedByDefault: boolean;

  closeMenu: () => void;

  setHoverGroupIndex: (hoveGroupIndex: number) => void;
  onToggleGroup: (groupId: string, opened: boolean) => void;
};

export function LinksGroups({
  linksGroups,
  level,
  counters,
  countersMaxNumber = null,
  showCountersInOpenedState,
  renderType,

  linksPath = undefined,
  hoverGroupIndex = null,
  openedGroups,
  openedByDefault,

  closeMenu,
  setHoverGroupIndex,
  onToggleGroup,
}: LinksGroupsProps): ReactElement {
  return (
    <div>
      {linksGroups.map((item, index) => renderGroupItem({
        level,
        counters,
        countersMaxNumber,
        showCountersInOpenedState,
        closeMenu,
        index,
        renderType,
        isHover: hoverGroupIndex === index,
        openedGroups,
        openedByDefault,
        setHoverGroupIndex,
        onToggleGroup,
      }, item, linksPath))}
    </div>
  );
}
